var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "tr",
    { staticClass: "grouprow" },
    _vm._l(_vm.cols.groupColumns, function (col) {
      return _c(
        "td",
        {
          key: col.key,
          class: col.class,
          style: col.style,
          attrs: { colspan: col.colspan },
        },
        [
          col.barField
            ? _c("div", { staticClass: "progress group-size-indicator" }, [
                _c(
                  "div",
                  {
                    staticClass: "progress-bar progress-bar-primary",
                    style: _vm.barStyle(col),
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(
                          _vm.row[col.labelField]?.toLocaleString() ??
                            _vm.$t("results.groupBy.groupNameWithoutValue")
                        ) +
                        "\n\t\t\t"
                    ),
                  ]
                ),
              ])
            : [_vm._v(_vm._s(_vm.valueForCell(col)))],
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }